module.exports = __webpack_public_path__ + "img/test_r10.8de15372.png";